(function() {
  window.Home = window.Home || {};
  Home.Behaviors = Home.Behaviors || {};

  Home.Behaviors.Tracking = {

      // see https://marketing.adobe.com/resources/help/en_US/sc/implement/function_tl.html
      // make sure tracking strings are less than 100 chars total

      track: function(delayParam, typeParam, nameParam) {
        HF.jsLoaded.then(() => {
          FS.Analytics.trackLink(delayParam, typeParam, nameParam);
        }); 
      },

      trackName: function(nameParam) {
        HF.jsLoaded.then(() => {
          FS.Analytics.trackValue(nameParam);
        });
      }
  };
}());
